<template>
  <component
    :is="name"
    v-bind="$props" />
</template>

<script>
import send from "./SendIcon";
import calendar from "@/icons/CalendarIcon";
import home from "@/icons/HomeIcon";
import report from "@/icons/ReportIcon";
import settings from "@/icons/SettingsIcon";
import trash from "@/icons/TrashIcon";
import save from "@/icons/SaveIcon";
import plus from "@/icons/PlusIcon";
import arrow from "@/icons/ArrowIcon";
import edit from "@/icons/EditIcon";
import search from "@/icons/SearchIcon";
import refund from "@/icons/RefundIcon";
import success from "@/icons/SuccessIcon";
import close from "@/icons/CloseIcon";
import bars from "@/icons/MenuIcon";
import overflow from "@/icons/OverflowIcon";
import bubble from "@/icons/BubbleIcon";
import error from "@/icons/ErrorIcon";
import info from "@/icons/InfoIcon";
import loading from "@/icons/LoadingIcon";
import download from "@/icons/DownloadIcon";

export default {
  components: {
    refund,
    search,
    edit,
    arrow,
    plus,
    save,
    trash,
    send,
    calendar,
    home,
    report,
    settings,
    success,
    close,
    bars,
    overflow,
    bubble,
    error,
    info,
    loading,
    download,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      default: "up",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 21,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
  display: inline-block;
  vertical-align: bottom;
}
</style>
